import React, { useState } from "react";

export default function HiddenImg({ isHidden, onToggle }) {
  return (
    <div>

      <label className="sp-um__toggle">
        <span>
          {isHidden
            ? <><i className="uil uil-image"></i> Imagen: Sí, Visible</>
            : <><i className="uil uil-image-alt-slash"></i> Imagen: No, Visible</>
          }
        </span>
        <input type="checkbox" checked={isHidden} onChange={onToggle} />
        <span className="sp-um__switch" aria-hidden="true"></span>
      </label>     
    </div>
  );
}

